/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const GetAddressUtxosByAddressParams = zod.object({
  "address": zod.string()
})

export const getAddressUtxosByAddressResponseUtxosItemAssetsItemQuantityMin = 0;

export const getAddressUtxosByAddressResponseUtxosItemBlockSlotMin = 0;

export const getAddressUtxosByAddressResponseUtxosItemIndexMin = 0;



export const GetAddressUtxosByAddressResponse = zod.object({
  "address": zod.string(),
  "found": zod.boolean(),
  "utxos": zod.array(zod.object({
  "address": zod.string(),
  "assets": zod.array(zod.object({
  "id": zod.string(),
  "quantity": zod.int().min(getAddressUtxosByAddressResponseUtxosItemAssetsItemQuantityMin)
})),
  "block_id": zod.string(),
  "block_slot": zod.int().min(getAddressUtxosByAddressResponseUtxosItemBlockSlotMin),
  "datum": zod.unknown(),
  "index": zod.int().min(getAddressUtxosByAddressResponseUtxosItemIndexMin),
  "tx_id": zod.string()
}))
})


export const GetArbitragesQueryParams = zod.object({
  "min_profit_ada": zod.number().optional().describe('Only opportunities whose profit is at least this many ADA. A viewing filter: the bot\nstill detects and records everything below it.')
})

export const getArbitragesResponseArbitragesItemBuyPoolOutputIndexMin = 0;

export const getArbitragesResponseArbitragesItemProfitLovelaceMin = 0;

export const getArbitragesResponseArbitragesItemSellPoolOutputIndexMin = 0;



export const GetArbitragesResponse = zod.object({
  "arbitrages": zod.array(zod.object({
  "buy_amount": zod.string(),
  "buy_cost_ada": zod.string(),
  "buy_pool": zod.string(),
  "buy_pool_output_index": zod.int().min(getArbitragesResponseArbitragesItemBuyPoolOutputIndexMin),
  "buy_pool_tvl": zod.string(),
  "buy_pool_tx_id": zod.string(),
  "buy_receive_amount": zod.string(),
  "buy_token_id": zod.string().describe('The bought token\'s unit id, so the UI can link it to an explorer.'),
  "buy_token_name": zod.string(),
  "profit_formatted": zod.string(),
  "profit_lovelace": zod.int().min(getArbitragesResponseArbitragesItemProfitLovelaceMin),
  "sell_pool": zod.string(),
  "sell_pool_output_index": zod.int().min(getArbitragesResponseArbitragesItemSellPoolOutputIndexMin),
  "sell_pool_tvl": zod.string(),
  "sell_pool_tx_id": zod.string(),
  "sell_receive_amount": zod.string(),
  "sell_token_name": zod.string(),
  "timestamp": zod.string()
}))
})


export const GetExecuteTradeResponse = zod.boolean()


export const getArbitragesHistoryResponseTransactionItemTransactionInputsItemIndexMin = 0;



export const GetArbitragesHistoryResponse = zod.object({
  "transaction": zod.array(zod.object({
  "arbitrage_text": zod.string(),
  "transaction": zod.object({
  "datums": zod.unknown().optional(),
  "id": zod.string(),
  "inputs": zod.array(zod.object({
  "index": zod.int().min(getArbitragesHistoryResponseTransactionItemTransactionInputsItemIndexMin),
  "transaction": zod.object({
  "id": zod.string()
})
})),
  "outputs": zod.array(zod.object({
  "address": zod.string(),
  "datum": zod.unknown().optional(),
  "datumHash": zod.string().nullish(),
  "value": zod.looseObject({

})
})),
  "scripts": zod.unknown().optional(),
  "signatories": zod.array(zod.unknown()).nullish()
})
}))
})


export const GetAvailableDexesResponse = zod.object({
  "available_dexes": zod.array(zod.string())
})


export const getOpportunitiesQueryLimitMin = 0;

export const getOpportunitiesQueryPageMin = 0;



export const GetOpportunitiesQueryParams = zod.object({
  "actionable_only": zod.boolean().optional().describe('Only windows that clear the thresholds (default true).'),
  "limit": zod.int().min(getOpportunitiesQueryLimitMin).optional().describe('Page size, 1–200 (default 50).'),
  "page": zod.int().min(getOpportunitiesQueryPageMin).optional().describe('The 1-based page, newest first (default 1).'),
  "pair": zod.string().optional().describe('Only this pair (`lovelace/<unit>`).')
})

export const getOpportunitiesResponsePageMin = 0;

export const getOpportunitiesResponseTotalMin = 0;

export const getOpportunitiesResponseWindowsItemDurationSecsMin = 0;

export const getOpportunitiesResponseWindowsItemWindowClosedAtMin = 0;

export const getOpportunitiesResponseWindowsItemWindowClosedSlotMin = 0;

export const getOpportunitiesResponseWindowsItemWindowDroppedEventsMin = 0;

export const getOpportunitiesResponseWindowsItemWindowFirstProfitLovelaceMin = 0;

export const getOpportunitiesResponseWindowsItemWindowIdMin = 0;

export const getOpportunitiesResponseWindowsItemWindowLastProfitLovelaceMin = 0;

export const getOpportunitiesResponseWindowsItemWindowLastSeenAtMin = 0;

export const getOpportunitiesResponseWindowsItemWindowLastSeenSlotMin = 0;

export const getOpportunitiesResponseWindowsItemWindowOpenedAtMin = 0;

export const getOpportunitiesResponseWindowsItemWindowOpenedSlotMin = 0;

export const getOpportunitiesResponseWindowsItemWindowPeakBuyAmountLovelaceMin = 0;

export const getOpportunitiesResponseWindowsItemWindowPeakBuyPoolTvlLovelaceMin = 0;

export const getOpportunitiesResponseWindowsItemWindowPeakSellPoolTvlLovelaceMin = 0;

export const getOpportunitiesResponseWindowsItemWindowPeakSellReceiveLovelaceMin = 0;

export const getOpportunitiesResponseWindowsItemWindowPeakProfitLovelaceMin = 0;

export const getOpportunitiesResponseWindowsItemWindowRecordedEventsMin = 0;



export const GetOpportunitiesResponse = zod.object({
  "page": zod.int().min(getOpportunitiesResponsePageMin).describe('The 1-based page these windows are; past the end it is empty.'),
  "total": zod.int().min(getOpportunitiesResponseTotalMin).describe('Every window that matches the filter, across all pages.'),
  "windows": zod.array(zod.object({
  "actionable": zod.boolean(),
  "duration_secs": zod.int().min(getOpportunitiesResponseWindowsItemDurationSecsMin),
  "window": zod.object({
  "alert_raised": zod.boolean().optional().describe('A phone alert went out and its follow-up has not. Persisted so the next start can send\nthe follow-up for a window the previous run left raised.'),
  "closed_at": zod.int().min(getOpportunitiesResponseWindowsItemWindowClosedAtMin).nullish(),
  "closed_slot": zod.int().min(getOpportunitiesResponseWindowsItemWindowClosedSlotMin).nullish(),
  "dropped_events": zod.int().min(getOpportunitiesResponseWindowsItemWindowDroppedEventsMin).describe('Events beyond the per-window cap: counted, not stored.'),
  "first_profit_lovelace": zod.int().min(getOpportunitiesResponseWindowsItemWindowFirstProfitLovelaceMin),
  "id": zod.int().min(getOpportunitiesResponseWindowsItemWindowIdMin),
  "last_profit_lovelace": zod.int().min(getOpportunitiesResponseWindowsItemWindowLastProfitLovelaceMin),
  "last_seen_at": zod.int().min(getOpportunitiesResponseWindowsItemWindowLastSeenAtMin),
  "last_seen_slot": zod.int().min(getOpportunitiesResponseWindowsItemWindowLastSeenSlotMin),
  "opened_at": zod.int().min(getOpportunitiesResponseWindowsItemWindowOpenedAtMin),
  "opened_slot": zod.int().min(getOpportunitiesResponseWindowsItemWindowOpenedSlotMin),
  "pair": zod.string(),
  "peak": zod.object({
  "buy_amount_lovelace": zod.int().min(getOpportunitiesResponseWindowsItemWindowPeakBuyAmountLovelaceMin),
  "buy_dex": zod.string(),
  "buy_pool_tvl_lovelace": zod.int().min(getOpportunitiesResponseWindowsItemWindowPeakBuyPoolTvlLovelaceMin),
  "buy_pool_utxo": zod.string(),
  "sell_dex": zod.string(),
  "sell_pool_tvl_lovelace": zod.int().min(getOpportunitiesResponseWindowsItemWindowPeakSellPoolTvlLovelaceMin),
  "sell_pool_utxo": zod.string(),
  "sell_receive_lovelace": zod.int().min(getOpportunitiesResponseWindowsItemWindowPeakSellReceiveLovelaceMin),
  "token_amount": zod.string()
}).describe('The trade at the peak profit.'),
  "peak_profit_lovelace": zod.int().min(getOpportunitiesResponseWindowsItemWindowPeakProfitLovelaceMin),
  "recorded_events": zod.int().min(getOpportunitiesResponseWindowsItemWindowRecordedEventsMin),
  "status": zod.enum(['open', 'closed', 'interrupted']),
  "token_name": zod.string()
})
}).describe('A window as the API serves it: classified against the thresholds in force.'))
})


export const getNotificationsResponseFailedMin = 0;

export const getNotificationsResponseLastErrorAtMin = 0;

export const getNotificationsResponseLastSentAtMin = 0;

export const getNotificationsResponseMaxLagSecsMin = 0;

export const getNotificationsResponseSentMin = 0;

export const getNotificationsResponseThresholdsEffectiveMinDurationSecsMin = 0;

export const getNotificationsResponseThresholdsEffectiveMinProfitLovelaceMin = 0;

export const getNotificationsResponseThresholdsEnvDefaultMinDurationSecsMin = 0;

export const getNotificationsResponseThresholdsEnvDefaultMinProfitLovelaceMin = 0;



export const GetNotificationsResponse = zod.object({
  "channel": zod.union([zod.object({
  "kind": zod.string(),
  "target": zod.string()
}).describe('Where alerts go, as the UI shows it. Never carries a secret.'),zod.null()]).optional(),
  "enabled": zod.boolean().describe('False when no channel is configured: nothing is ever sent.'),
  "failed": zod.int().min(getNotificationsResponseFailedMin),
  "last_error": zod.string().nullish(),
  "last_error_at": zod.int().min(getNotificationsResponseLastErrorAtMin).nullish(),
  "last_sent_at": zod.int().min(getNotificationsResponseLastSentAtMin).nullish(),
  "max_lag_secs": zod.int().min(getNotificationsResponseMaxLagSecsMin).describe('Windows that open further behind wall clock than this are replays and never alert.'),
  "sent": zod.int().min(getNotificationsResponseSentMin).describe('Deliveries since the bot started.'),
  "thresholds": zod.object({
  "effective": zod.object({
  "min_duration_secs": zod.int().min(getNotificationsResponseThresholdsEffectiveMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(getNotificationsResponseThresholdsEffectiveMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "env_default": zod.object({
  "min_duration_secs": zod.int().min(getNotificationsResponseThresholdsEnvDefaultMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(getNotificationsResponseThresholdsEnvDefaultMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "overridden": zod.boolean().describe('True while a value saved from the UI replaces the env default.')
}).describe('What a window must clear to alert: open at least `min_duration_secs` with a current\nprofit of at least `min_profit_lovelace`.')
})


export const setNotifyThresholdsBodyMinDurationSecsMin = 0;

export const setNotifyThresholdsBodyMinProfitLovelaceMin = 0;



export const SetNotifyThresholdsBody = zod.object({
  "min_duration_secs": zod.int().min(setNotifyThresholdsBodyMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(setNotifyThresholdsBodyMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.')

export const setNotifyThresholdsResponseFailedMin = 0;

export const setNotifyThresholdsResponseLastErrorAtMin = 0;

export const setNotifyThresholdsResponseLastSentAtMin = 0;

export const setNotifyThresholdsResponseMaxLagSecsMin = 0;

export const setNotifyThresholdsResponseSentMin = 0;

export const setNotifyThresholdsResponseThresholdsEffectiveMinDurationSecsMin = 0;

export const setNotifyThresholdsResponseThresholdsEffectiveMinProfitLovelaceMin = 0;

export const setNotifyThresholdsResponseThresholdsEnvDefaultMinDurationSecsMin = 0;

export const setNotifyThresholdsResponseThresholdsEnvDefaultMinProfitLovelaceMin = 0;



export const SetNotifyThresholdsResponse = zod.object({
  "channel": zod.union([zod.object({
  "kind": zod.string(),
  "target": zod.string()
}).describe('Where alerts go, as the UI shows it. Never carries a secret.'),zod.null()]).optional(),
  "enabled": zod.boolean().describe('False when no channel is configured: nothing is ever sent.'),
  "failed": zod.int().min(setNotifyThresholdsResponseFailedMin),
  "last_error": zod.string().nullish(),
  "last_error_at": zod.int().min(setNotifyThresholdsResponseLastErrorAtMin).nullish(),
  "last_sent_at": zod.int().min(setNotifyThresholdsResponseLastSentAtMin).nullish(),
  "max_lag_secs": zod.int().min(setNotifyThresholdsResponseMaxLagSecsMin).describe('Windows that open further behind wall clock than this are replays and never alert.'),
  "sent": zod.int().min(setNotifyThresholdsResponseSentMin).describe('Deliveries since the bot started.'),
  "thresholds": zod.object({
  "effective": zod.object({
  "min_duration_secs": zod.int().min(setNotifyThresholdsResponseThresholdsEffectiveMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(setNotifyThresholdsResponseThresholdsEffectiveMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "env_default": zod.object({
  "min_duration_secs": zod.int().min(setNotifyThresholdsResponseThresholdsEnvDefaultMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(setNotifyThresholdsResponseThresholdsEnvDefaultMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "overridden": zod.boolean().describe('True while a value saved from the UI replaces the env default.')
}).describe('What a window must clear to alert: open at least `min_duration_secs` with a current\nprofit of at least `min_profit_lovelace`.')
})


export const resetNotifyThresholdsResponseFailedMin = 0;

export const resetNotifyThresholdsResponseLastErrorAtMin = 0;

export const resetNotifyThresholdsResponseLastSentAtMin = 0;

export const resetNotifyThresholdsResponseMaxLagSecsMin = 0;

export const resetNotifyThresholdsResponseSentMin = 0;

export const resetNotifyThresholdsResponseThresholdsEffectiveMinDurationSecsMin = 0;

export const resetNotifyThresholdsResponseThresholdsEffectiveMinProfitLovelaceMin = 0;

export const resetNotifyThresholdsResponseThresholdsEnvDefaultMinDurationSecsMin = 0;

export const resetNotifyThresholdsResponseThresholdsEnvDefaultMinProfitLovelaceMin = 0;



export const ResetNotifyThresholdsResponse = zod.object({
  "channel": zod.union([zod.object({
  "kind": zod.string(),
  "target": zod.string()
}).describe('Where alerts go, as the UI shows it. Never carries a secret.'),zod.null()]).optional(),
  "enabled": zod.boolean().describe('False when no channel is configured: nothing is ever sent.'),
  "failed": zod.int().min(resetNotifyThresholdsResponseFailedMin),
  "last_error": zod.string().nullish(),
  "last_error_at": zod.int().min(resetNotifyThresholdsResponseLastErrorAtMin).nullish(),
  "last_sent_at": zod.int().min(resetNotifyThresholdsResponseLastSentAtMin).nullish(),
  "max_lag_secs": zod.int().min(resetNotifyThresholdsResponseMaxLagSecsMin).describe('Windows that open further behind wall clock than this are replays and never alert.'),
  "sent": zod.int().min(resetNotifyThresholdsResponseSentMin).describe('Deliveries since the bot started.'),
  "thresholds": zod.object({
  "effective": zod.object({
  "min_duration_secs": zod.int().min(resetNotifyThresholdsResponseThresholdsEffectiveMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(resetNotifyThresholdsResponseThresholdsEffectiveMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "env_default": zod.object({
  "min_duration_secs": zod.int().min(resetNotifyThresholdsResponseThresholdsEnvDefaultMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(resetNotifyThresholdsResponseThresholdsEnvDefaultMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "overridden": zod.boolean().describe('True while a value saved from the UI replaces the env default.')
}).describe('What a window must clear to alert: open at least `min_duration_secs` with a current\nprofit of at least `min_profit_lovelace`.')
})


export const sendTestNotificationResponseFailedMin = 0;

export const sendTestNotificationResponseLastErrorAtMin = 0;

export const sendTestNotificationResponseLastSentAtMin = 0;

export const sendTestNotificationResponseMaxLagSecsMin = 0;

export const sendTestNotificationResponseSentMin = 0;

export const sendTestNotificationResponseThresholdsEffectiveMinDurationSecsMin = 0;

export const sendTestNotificationResponseThresholdsEffectiveMinProfitLovelaceMin = 0;

export const sendTestNotificationResponseThresholdsEnvDefaultMinDurationSecsMin = 0;

export const sendTestNotificationResponseThresholdsEnvDefaultMinProfitLovelaceMin = 0;



export const SendTestNotificationResponse = zod.object({
  "channel": zod.union([zod.object({
  "kind": zod.string(),
  "target": zod.string()
}).describe('Where alerts go, as the UI shows it. Never carries a secret.'),zod.null()]).optional(),
  "enabled": zod.boolean().describe('False when no channel is configured: nothing is ever sent.'),
  "failed": zod.int().min(sendTestNotificationResponseFailedMin),
  "last_error": zod.string().nullish(),
  "last_error_at": zod.int().min(sendTestNotificationResponseLastErrorAtMin).nullish(),
  "last_sent_at": zod.int().min(sendTestNotificationResponseLastSentAtMin).nullish(),
  "max_lag_secs": zod.int().min(sendTestNotificationResponseMaxLagSecsMin).describe('Windows that open further behind wall clock than this are replays and never alert.'),
  "sent": zod.int().min(sendTestNotificationResponseSentMin).describe('Deliveries since the bot started.'),
  "thresholds": zod.object({
  "effective": zod.object({
  "min_duration_secs": zod.int().min(sendTestNotificationResponseThresholdsEffectiveMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(sendTestNotificationResponseThresholdsEffectiveMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "env_default": zod.object({
  "min_duration_secs": zod.int().min(sendTestNotificationResponseThresholdsEnvDefaultMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(sendTestNotificationResponseThresholdsEnvDefaultMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "overridden": zod.boolean().describe('True while a value saved from the UI replaces the env default.')
}).describe('What a window must clear to alert: open at least `min_duration_secs` with a current\nprofit of at least `min_profit_lovelace`.')
})


export const pruneOpportunitiesBodyFromMin = 0;

export const pruneOpportunitiesBodyOlderThanDaysMin = 0;

export const pruneOpportunitiesBodyToMin = 0;



export const PruneOpportunitiesBody = zod.object({
  "all": zod.boolean().optional().describe('Drop all closed opportunity windows and their event audit trails.'),
  "from": zod.int().min(pruneOpportunitiesBodyFromMin).nullish().describe('Drop closed windows whose opening timestamp is >= `from` (UTC unix seconds).'),
  "older_than_days": zod.int().min(pruneOpportunitiesBodyOlderThanDaysMin).nullish().describe('Drop closed windows older than this many days from now.'),
  "to": zod.int().min(pruneOpportunitiesBodyToMin).nullish().describe('Drop closed windows whose end timestamp is <= `to` (UTC unix seconds).')
})

export const pruneOpportunitiesResponsePrunedMin = 0;

export const pruneOpportunitiesResponseStoreBytesMin = 0;



export const PruneOpportunitiesResponse = zod.object({
  "pruned": zod.int().min(pruneOpportunitiesResponsePrunedMin),
  "store_bytes": zod.int().min(pruneOpportunitiesResponseStoreBytesMin)
})


export const getOpportunityStatsQueryDaysMin = 0;



export const GetOpportunityStatsQueryParams = zod.object({
  "days": zod.int().min(getOpportunityStatsQueryDaysMin).optional().describe('UTC days back from the newest chain time, 1–90 (default 14).'),
  "pair": zod.string().optional().describe('Only this pair (`lovelace/<unit>`), as the top pairs name it.')
})

export const getOpportunityStatsResponseDaysItemOneActionableMin = 0;

export const getOpportunityStatsResponseDaysItemOneAvgDurationSecsMin = 0;

export const getOpportunityStatsResponseDaysItemOneBestProfitLovelaceMin = 0;

export const getOpportunityStatsResponseDaysItemOneLongestDurationSecsMin = 0;

export const getOpportunityStatsResponseDaysItemOneOpportunitiesMin = 0;

export const getOpportunityStatsResponseDaysItemOnePotentialProfitLovelaceMin = 0;

export const getOpportunityStatsResponseOldestOpenedAtMin = 0;

export const getOpportunityStatsResponseOpenNowMin = 0;

export const getOpportunityStatsResponseRetentionDaysMin = 0;

export const getOpportunityStatsResponseStoreBytesMin = 0;

export const getOpportunityStatsResponseStoredWindowsMin = 0;

export const getOpportunityStatsResponseThresholdsMinDurationSecsMin = 0;

export const getOpportunityStatsResponseThresholdsMinProfitLovelaceMin = 0;

export const getOpportunityStatsResponseTopPairsItemOneActionableMin = 0;

export const getOpportunityStatsResponseTopPairsItemOneAvgDurationSecsMin = 0;

export const getOpportunityStatsResponseTopPairsItemOneBestProfitLovelaceMin = 0;

export const getOpportunityStatsResponseTopPairsItemOneLongestDurationSecsMin = 0;

export const getOpportunityStatsResponseTopPairsItemOneOpportunitiesMin = 0;

export const getOpportunityStatsResponseTopPairsItemOnePotentialProfitLovelaceMin = 0;

export const getOpportunityStatsResponseTotalsActionableMin = 0;

export const getOpportunityStatsResponseTotalsAvgDurationSecsMin = 0;

export const getOpportunityStatsResponseTotalsBestProfitLovelaceMin = 0;

export const getOpportunityStatsResponseTotalsLongestDurationSecsMin = 0;

export const getOpportunityStatsResponseTotalsOpportunitiesMin = 0;

export const getOpportunityStatsResponseTotalsPotentialProfitLovelaceMin = 0;



export const GetOpportunityStatsResponse = zod.object({
  "days": zod.array(zod.object({
  "actionable": zod.int().min(getOpportunityStatsResponseDaysItemOneActionableMin),
  "avg_duration_secs": zod.int().min(getOpportunityStatsResponseDaysItemOneAvgDurationSecsMin),
  "best_profit_lovelace": zod.int().min(getOpportunityStatsResponseDaysItemOneBestProfitLovelaceMin),
  "longest_duration_secs": zod.int().min(getOpportunityStatsResponseDaysItemOneLongestDurationSecsMin),
  "opportunities": zod.int().min(getOpportunityStatsResponseDaysItemOneOpportunitiesMin),
  "potential_profit_lovelace": zod.int().min(getOpportunityStatsResponseDaysItemOnePotentialProfitLovelaceMin).describe('Sum of the actionable windows\' peak profits: what taking every one would have earned.')
}).and(zod.object({
  "date": zod.string().describe('UTC calendar day (`YYYY-MM-DD`) the windows opened on.')
}))).describe('Newest first, one row per day of the range, empty days included.'),
  "oldest_opened_at": zod.int().min(getOpportunityStatsResponseOldestOpenedAtMin).nullish(),
  "open_now": zod.int().min(getOpportunityStatsResponseOpenNowMin),
  "retention_days": zod.int().min(getOpportunityStatsResponseRetentionDaysMin),
  "store_bytes": zod.int().min(getOpportunityStatsResponseStoreBytesMin),
  "stored_windows": zod.int().min(getOpportunityStatsResponseStoredWindowsMin),
  "thresholds": zod.object({
  "min_duration_secs": zod.int().min(getOpportunityStatsResponseThresholdsMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(getOpportunityStatsResponseThresholdsMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "top_pairs": zod.array(zod.object({
  "actionable": zod.int().min(getOpportunityStatsResponseTopPairsItemOneActionableMin),
  "avg_duration_secs": zod.int().min(getOpportunityStatsResponseTopPairsItemOneAvgDurationSecsMin),
  "best_profit_lovelace": zod.int().min(getOpportunityStatsResponseTopPairsItemOneBestProfitLovelaceMin),
  "longest_duration_secs": zod.int().min(getOpportunityStatsResponseTopPairsItemOneLongestDurationSecsMin),
  "opportunities": zod.int().min(getOpportunityStatsResponseTopPairsItemOneOpportunitiesMin),
  "potential_profit_lovelace": zod.int().min(getOpportunityStatsResponseTopPairsItemOnePotentialProfitLovelaceMin).describe('Sum of the actionable windows\' peak profits: what taking every one would have earned.')
}).and(zod.object({
  "pair": zod.string(),
  "token_name": zod.string()
}))),
  "totals": zod.object({
  "actionable": zod.int().min(getOpportunityStatsResponseTotalsActionableMin),
  "avg_duration_secs": zod.int().min(getOpportunityStatsResponseTotalsAvgDurationSecsMin),
  "best_profit_lovelace": zod.int().min(getOpportunityStatsResponseTotalsBestProfitLovelaceMin),
  "longest_duration_secs": zod.int().min(getOpportunityStatsResponseTotalsLongestDurationSecsMin),
  "opportunities": zod.int().min(getOpportunityStatsResponseTotalsOpportunitiesMin),
  "potential_profit_lovelace": zod.int().min(getOpportunityStatsResponseTotalsPotentialProfitLovelaceMin).describe('Sum of the actionable windows\' peak profits: what taking every one would have earned.')
})
})


export const getOpportunityThresholdsResponseEffectiveMinDurationSecsMin = 0;

export const getOpportunityThresholdsResponseEffectiveMinProfitLovelaceMin = 0;

export const getOpportunityThresholdsResponseEnvDefaultMinDurationSecsMin = 0;

export const getOpportunityThresholdsResponseEnvDefaultMinProfitLovelaceMin = 0;



export const GetOpportunityThresholdsResponse = zod.object({
  "effective": zod.object({
  "min_duration_secs": zod.int().min(getOpportunityThresholdsResponseEffectiveMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(getOpportunityThresholdsResponseEffectiveMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "env_default": zod.object({
  "min_duration_secs": zod.int().min(getOpportunityThresholdsResponseEnvDefaultMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(getOpportunityThresholdsResponseEnvDefaultMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "overridden": zod.boolean().describe('True while a value saved from the UI replaces the env default.')
})


export const setOpportunityThresholdsBodyMinDurationSecsMin = 0;

export const setOpportunityThresholdsBodyMinProfitLovelaceMin = 0;



export const SetOpportunityThresholdsBody = zod.object({
  "min_duration_secs": zod.int().min(setOpportunityThresholdsBodyMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(setOpportunityThresholdsBodyMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.')

export const setOpportunityThresholdsResponseEffectiveMinDurationSecsMin = 0;

export const setOpportunityThresholdsResponseEffectiveMinProfitLovelaceMin = 0;

export const setOpportunityThresholdsResponseEnvDefaultMinDurationSecsMin = 0;

export const setOpportunityThresholdsResponseEnvDefaultMinProfitLovelaceMin = 0;



export const SetOpportunityThresholdsResponse = zod.object({
  "effective": zod.object({
  "min_duration_secs": zod.int().min(setOpportunityThresholdsResponseEffectiveMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(setOpportunityThresholdsResponseEffectiveMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "env_default": zod.object({
  "min_duration_secs": zod.int().min(setOpportunityThresholdsResponseEnvDefaultMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(setOpportunityThresholdsResponseEnvDefaultMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "overridden": zod.boolean().describe('True while a value saved from the UI replaces the env default.')
})


export const resetOpportunityThresholdsResponseEffectiveMinDurationSecsMin = 0;

export const resetOpportunityThresholdsResponseEffectiveMinProfitLovelaceMin = 0;

export const resetOpportunityThresholdsResponseEnvDefaultMinDurationSecsMin = 0;

export const resetOpportunityThresholdsResponseEnvDefaultMinProfitLovelaceMin = 0;



export const ResetOpportunityThresholdsResponse = zod.object({
  "effective": zod.object({
  "min_duration_secs": zod.int().min(resetOpportunityThresholdsResponseEffectiveMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(resetOpportunityThresholdsResponseEffectiveMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "env_default": zod.object({
  "min_duration_secs": zod.int().min(resetOpportunityThresholdsResponseEnvDefaultMinDurationSecsMin),
  "min_profit_lovelace": zod.int().min(resetOpportunityThresholdsResponseEnvDefaultMinProfitLovelaceMin)
}).describe('What makes a window worth a human\'s attention. Applied when reading, so changing it\nre-classifies everything already recorded.'),
  "overridden": zod.boolean().describe('True while a value saved from the UI replaces the env default.')
})


export const getOpportunityPathIdMin = 0;



export const GetOpportunityParams = zod.object({
  "id": zod.int().min(getOpportunityPathIdMin)
})

export const getOpportunityResponseEventsItemAtMin = 0;

export const getOpportunityResponseEventsItemProfitLovelaceMin = 0;

export const getOpportunityResponseEventsItemSeqMin = 0;

export const getOpportunityResponseEventsItemSlotMin = 0;

export const getOpportunityResponseEventsItemTradeOneBuyAmountLovelaceMin = 0;

export const getOpportunityResponseEventsItemTradeOneBuyPoolTvlLovelaceMin = 0;

export const getOpportunityResponseEventsItemTradeOneSellPoolTvlLovelaceMin = 0;

export const getOpportunityResponseEventsItemTradeOneSellReceiveLovelaceMin = 0;

export const getOpportunityResponseOpportunityDurationSecsMin = 0;

export const getOpportunityResponseOpportunityWindowClosedAtMin = 0;

export const getOpportunityResponseOpportunityWindowClosedSlotMin = 0;

export const getOpportunityResponseOpportunityWindowDroppedEventsMin = 0;

export const getOpportunityResponseOpportunityWindowFirstProfitLovelaceMin = 0;

export const getOpportunityResponseOpportunityWindowIdMin = 0;

export const getOpportunityResponseOpportunityWindowLastProfitLovelaceMin = 0;

export const getOpportunityResponseOpportunityWindowLastSeenAtMin = 0;

export const getOpportunityResponseOpportunityWindowLastSeenSlotMin = 0;

export const getOpportunityResponseOpportunityWindowOpenedAtMin = 0;

export const getOpportunityResponseOpportunityWindowOpenedSlotMin = 0;

export const getOpportunityResponseOpportunityWindowPeakBuyAmountLovelaceMin = 0;

export const getOpportunityResponseOpportunityWindowPeakBuyPoolTvlLovelaceMin = 0;

export const getOpportunityResponseOpportunityWindowPeakSellPoolTvlLovelaceMin = 0;

export const getOpportunityResponseOpportunityWindowPeakSellReceiveLovelaceMin = 0;

export const getOpportunityResponseOpportunityWindowPeakProfitLovelaceMin = 0;

export const getOpportunityResponseOpportunityWindowRecordedEventsMin = 0;



export const GetOpportunityResponse = zod.object({
  "events": zod.array(zod.object({
  "at": zod.int().min(getOpportunityResponseEventsItemAtMin),
  "kind": zod.enum(['opened', 'updated', 'closed', 'interrupted', 'notified', 'notify_failed']),
  "note": zod.string().nullish(),
  "profit_lovelace": zod.int().min(getOpportunityResponseEventsItemProfitLovelaceMin).nullish(),
  "seq": zod.int().min(getOpportunityResponseEventsItemSeqMin),
  "slot": zod.int().min(getOpportunityResponseEventsItemSlotMin),
  "trade": zod.union([zod.object({
  "buy_amount_lovelace": zod.int().min(getOpportunityResponseEventsItemTradeOneBuyAmountLovelaceMin),
  "buy_dex": zod.string(),
  "buy_pool_tvl_lovelace": zod.int().min(getOpportunityResponseEventsItemTradeOneBuyPoolTvlLovelaceMin),
  "buy_pool_utxo": zod.string(),
  "sell_dex": zod.string(),
  "sell_pool_tvl_lovelace": zod.int().min(getOpportunityResponseEventsItemTradeOneSellPoolTvlLovelaceMin),
  "sell_pool_utxo": zod.string(),
  "sell_receive_lovelace": zod.int().min(getOpportunityResponseEventsItemTradeOneSellReceiveLovelaceMin),
  "token_amount": zod.string()
}).describe('The trade the bot computed at one observation: enough to find both pools on an explorer and\ncheck the numbers. Its own type rather than [`ArbitrageDisplayItem`], so a change to the live\npage\'s shape cannot make recorded history undecodable.'),zod.null()]).optional()
})),
  "opportunity": zod.object({
  "actionable": zod.boolean(),
  "duration_secs": zod.int().min(getOpportunityResponseOpportunityDurationSecsMin),
  "window": zod.object({
  "alert_raised": zod.boolean().optional().describe('A phone alert went out and its follow-up has not. Persisted so the next start can send\nthe follow-up for a window the previous run left raised.'),
  "closed_at": zod.int().min(getOpportunityResponseOpportunityWindowClosedAtMin).nullish(),
  "closed_slot": zod.int().min(getOpportunityResponseOpportunityWindowClosedSlotMin).nullish(),
  "dropped_events": zod.int().min(getOpportunityResponseOpportunityWindowDroppedEventsMin).describe('Events beyond the per-window cap: counted, not stored.'),
  "first_profit_lovelace": zod.int().min(getOpportunityResponseOpportunityWindowFirstProfitLovelaceMin),
  "id": zod.int().min(getOpportunityResponseOpportunityWindowIdMin),
  "last_profit_lovelace": zod.int().min(getOpportunityResponseOpportunityWindowLastProfitLovelaceMin),
  "last_seen_at": zod.int().min(getOpportunityResponseOpportunityWindowLastSeenAtMin),
  "last_seen_slot": zod.int().min(getOpportunityResponseOpportunityWindowLastSeenSlotMin),
  "opened_at": zod.int().min(getOpportunityResponseOpportunityWindowOpenedAtMin),
  "opened_slot": zod.int().min(getOpportunityResponseOpportunityWindowOpenedSlotMin),
  "pair": zod.string(),
  "peak": zod.object({
  "buy_amount_lovelace": zod.int().min(getOpportunityResponseOpportunityWindowPeakBuyAmountLovelaceMin),
  "buy_dex": zod.string(),
  "buy_pool_tvl_lovelace": zod.int().min(getOpportunityResponseOpportunityWindowPeakBuyPoolTvlLovelaceMin),
  "buy_pool_utxo": zod.string(),
  "sell_dex": zod.string(),
  "sell_pool_tvl_lovelace": zod.int().min(getOpportunityResponseOpportunityWindowPeakSellPoolTvlLovelaceMin),
  "sell_pool_utxo": zod.string(),
  "sell_receive_lovelace": zod.int().min(getOpportunityResponseOpportunityWindowPeakSellReceiveLovelaceMin),
  "token_amount": zod.string()
}).describe('The trade at the peak profit.'),
  "peak_profit_lovelace": zod.int().min(getOpportunityResponseOpportunityWindowPeakProfitLovelaceMin),
  "recorded_events": zod.int().min(getOpportunityResponseOpportunityWindowRecordedEventsMin),
  "status": zod.enum(['open', 'closed', 'interrupted']),
  "token_name": zod.string()
})
}).describe('A window as the API serves it: classified against the thresholds in force.')
})


export const GetPoolsByPairQueryParams = zod.object({
  "asset_a": zod.string(),
  "asset_b": zod.string()
})

export const getPoolsByPairResponsePoolsItemOutputIndexMin = 0;



export const GetPoolsByPairResponse = zod.object({
  "pools": zod.array(zod.object({
  "address": zod.string(),
  "asset_a": zod.object({
  "id": zod.string(),
  "name": zod.string()
}).describe('An asset as the UI names it: the ticker it shows and the unit id (`lovelace` for ADA) it links\nto on an explorer. [[spec-reusable-asset-hover-card-with-cardanoscan-links]]'),
  "asset_b": zod.object({
  "id": zod.string(),
  "name": zod.string()
}).describe('An asset as the UI names it: the ticker it shows and the unit id (`lovelace` for ADA) it links\nto on an explorer. [[spec-reusable-asset-hover-card-with-cardanoscan-links]]'),
  "buy_fee": zod.string(),
  "calculate_buy_100": zod.string(),
  "calculate_sell_100": zod.string(),
  "dex_name": zod.string(),
  "output_index": zod.int().min(getPoolsByPairResponsePoolsItemOutputIndexMin),
  "price": zod.string(),
  "reserve_a": zod.string(),
  "reserve_b": zod.string(),
  "sell_fee": zod.string(),
  "transaction_id": zod.string(),
  "tvl": zod.string()
}))
})


export const GetPoolsByDexParams = zod.object({
  "dex": zod.string()
})

export const getPoolsByDexQueryPageMin = 0;



export const GetPoolsByDexQueryParams = zod.object({
  "page": zod.int().min(getPoolsByDexQueryPageMin).optional()
})

export const getPoolsByDexResponseCurrentPageMin = 0;

export const getPoolsByDexResponsePageSizeMin = 0;

export const getPoolsByDexResponsePoolsItemOutputIndexMin = 0;

export const getPoolsByDexResponseTotalMin = 0;



export const GetPoolsByDexResponse = zod.object({
  "current_page": zod.int().min(getPoolsByDexResponseCurrentPageMin).describe('Zero-based.'),
  "page_size": zod.int().min(getPoolsByDexResponsePageSizeMin),
  "pools": zod.array(zod.object({
  "address": zod.string(),
  "asset_a": zod.object({
  "id": zod.string(),
  "name": zod.string()
}).describe('An asset as the UI names it: the ticker it shows and the unit id (`lovelace` for ADA) it links\nto on an explorer. [[spec-reusable-asset-hover-card-with-cardanoscan-links]]'),
  "asset_b": zod.object({
  "id": zod.string(),
  "name": zod.string()
}).describe('An asset as the UI names it: the ticker it shows and the unit id (`lovelace` for ADA) it links\nto on an explorer. [[spec-reusable-asset-hover-card-with-cardanoscan-links]]'),
  "buy_fee": zod.string(),
  "calculate_buy_100": zod.string(),
  "calculate_sell_100": zod.string(),
  "dex_name": zod.string(),
  "output_index": zod.int().min(getPoolsByDexResponsePoolsItemOutputIndexMin),
  "price": zod.string(),
  "reserve_a": zod.string(),
  "reserve_b": zod.string(),
  "sell_fee": zod.string(),
  "transaction_id": zod.string(),
  "tvl": zod.string()
})),
  "total": zod.int().min(getPoolsByDexResponseTotalMin).describe('Every pool the dex has, across all pages.')
})


export const GetRegulusAddressUtxosParams = zod.object({
  "address": zod.string()
})

export const getRegulusAddressUtxosResponseUtxosItemAssetsItemQuantityMin = 0;

export const getRegulusAddressUtxosResponseUtxosItemBlockSlotMin = 0;

export const getRegulusAddressUtxosResponseUtxosItemIndexMin = 0;



export const GetRegulusAddressUtxosResponse = zod.object({
  "address": zod.string(),
  "found": zod.boolean(),
  "utxos": zod.array(zod.object({
  "address": zod.string(),
  "assets": zod.array(zod.object({
  "id": zod.string(),
  "quantity": zod.int().min(getRegulusAddressUtxosResponseUtxosItemAssetsItemQuantityMin)
})),
  "block_id": zod.string(),
  "block_slot": zod.int().min(getRegulusAddressUtxosResponseUtxosItemBlockSlotMin),
  "datum": zod.unknown(),
  "index": zod.int().min(getRegulusAddressUtxosResponseUtxosItemIndexMin),
  "tx_id": zod.string()
}))
})


export const getRegulusPointResponseSlotMin = 0;



export const GetRegulusPointResponse = zod.object({
  "id": zod.string(),
  "slot": zod.int().min(getRegulusPointResponseSlotMin)
})


export const getRegulusUtxoQueryIndexMin = 0;



export const GetRegulusUtxoQueryParams = zod.object({
  "transaction_id": zod.string(),
  "index": zod.int().min(getRegulusUtxoQueryIndexMin)
})

export const getRegulusUtxoResponseAssetsItemQuantityMin = 0;

export const getRegulusUtxoResponseBlockSlotMin = 0;

export const getRegulusUtxoResponseIndexMin = 0;



export const GetRegulusUtxoResponse = zod.object({
  "address": zod.string(),
  "assets": zod.array(zod.object({
  "id": zod.string(),
  "quantity": zod.int().min(getRegulusUtxoResponseAssetsItemQuantityMin)
})),
  "block_id": zod.string(),
  "block_slot": zod.int().min(getRegulusUtxoResponseBlockSlotMin),
  "datum": zod.unknown(),
  "index": zod.int().min(getRegulusUtxoResponseIndexMin),
  "tx_id": zod.string()
})


export const lookupUtxoQueryIndexMin = 0;



export const LookupUtxoQueryParams = zod.object({
  "transaction_id": zod.string(),
  "index": zod.int().min(lookupUtxoQueryIndexMin)
})

export const lookupUtxoResponseUtxoAssetsItemQuantityMin = 0;

export const lookupUtxoResponseUtxoBlockSlotMin = 0;

export const lookupUtxoResponseUtxoIndexMin = 0;



export const LookupUtxoResponse = zod.object({
  "utxo": zod.object({
  "address": zod.string(),
  "assets": zod.array(zod.object({
  "id": zod.string(),
  "quantity": zod.int().min(lookupUtxoResponseUtxoAssetsItemQuantityMin)
})),
  "block_id": zod.string(),
  "block_slot": zod.int().min(lookupUtxoResponseUtxoBlockSlotMin),
  "datum": zod.unknown(),
  "index": zod.int().min(lookupUtxoResponseUtxoIndexMin),
  "tx_id": zod.string()
})
})


export const getWalletPointResponseSlotMin = 0;



export const GetWalletPointResponse = zod.object({
  "id": zod.string(),
  "slot": zod.int().min(getWalletPointResponseSlotMin)
})


export const getWalletUtxoQueryIndexMin = 0;



export const GetWalletUtxoQueryParams = zod.object({
  "transaction_id": zod.string(),
  "index": zod.int().min(getWalletUtxoQueryIndexMin)
})

export const getWalletUtxoResponseAssetsItemQuantityMin = 0;

export const getWalletUtxoResponseBlockSlotMin = 0;

export const getWalletUtxoResponseIndexMin = 0;



export const GetWalletUtxoResponse = zod.object({
  "address": zod.string(),
  "assets": zod.array(zod.object({
  "id": zod.string(),
  "quantity": zod.int().min(getWalletUtxoResponseAssetsItemQuantityMin)
})),
  "block_id": zod.string(),
  "block_slot": zod.int().min(getWalletUtxoResponseBlockSlotMin),
  "datum": zod.unknown(),
  "index": zod.int().min(getWalletUtxoResponseIndexMin),
  "tx_id": zod.string()
})
